export default function WhyChooseUs() {
  const reasons = [
    {
      icon: 'ri-medal-line',
      title: '20+ Years Experience',
      description: 'Sunil Saini ke paas 20+ saal ka electronics repair ka anubhav hai'
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Proper Testing',
      description: 'Har device ko repair se pehle achhe se test kiya jaata hai'
    },
    {
      icon: 'ri-money-rupee-circle-line',
      title: 'Reasonable Charges',
      description: 'Imandaar aur affordable pricing, koi hidden charges nahi'
    },
    {
      icon: 'ri-map-pin-user-line',
      title: 'Local Trusted Shop',
      description: 'Sikandrabad mein local aur bharosemand dukaan'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Kyun Chunein Sunil Electronics?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Humein apne kaam par poora bharosa hai aur customers ki satisfaction hamari priority hai
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {reasons.map((reason, index) => (
            <div 
              key={index}
              className="text-center group cursor-pointer"
            >
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-orange-400 to-orange-600 rounded-full mx-auto mb-6 shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-110">
                <i className={`${reason.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {reason.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
        
        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-orange-50 to-orange-100 px-8 py-6 rounded-xl border border-orange-200">
            <p className="text-gray-800 text-lg font-medium">
              <i className="ri-user-star-line text-orange-500 text-2xl mr-2"></i>
              Sunil Saini - 20+ saal ka anubhav, local aur imandaar technician
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
